export const primitiveColors = {
  'New Primitives Web': {
    'Blue/Background': '#E0EFFF',
    'Blue/Basic': '#007AFF',
    'Blue/Dark': '#1485FF',
    'Blue/Disabled': '#99CAFF',
    'Blue/Disabled Dark': '#003D80',
    'Blue/Hover': '#208BFF',
    'Blue/Hover Dark': '#007AFF',
    'Blue/Pressed': '#60ACFF',
    'Blue/Pressed Dark': '#006ADE',
    'Blue/Transparent': '#007AFF1F',
    'Blue/Transparent Dark': '#1485FF3D',
    'Blue/Transparent Scratch': '#015FC529',
    'Blue/Transparent Scratch Dark': '#015FC53D',
    'Brown/Background': '#EEE4DF',
    'Brown/Basic': '#B28772',
    'Brown/Dark': '#BA9380',
    'Brown/Disabled': '#D1B7AA',
    'Brown/Disabled Dark': '#6B5144',
    'Brown/Hover': '#BA9380',
    'Brown/Hover Dark': '#B28772',
    'Brown/Pressed': '#C19F8E',
    'Brown/Pressed Dark': '#A07A67',
    'Brown/Transparent': '#B287721F',
    'Brown/Transparent Dark': '#BA938047',
    'Brown/Transparent Scratch': '#87665629',
    'Brown/Transparent Scratch Dark': '#87665647',
    'Cool Grey/Basic': '#6D7B98',
    'Cool Grey/Dark': '#7C88A2',
    'Cool Grey/Disabled': '#A7B0C1',
    'Cool Grey/Disabled Dark': '#414A5B',
    'Cool Grey/Hover': '#7C88A2',
    'Cool Grey/Hover Dark': '#6D7B98',
    'Cool Grey/Pressed': '#8A95AD',
    'Cool Grey/Pressed Dark': '#626F89',
    'Cool Grey/Transparent': '#6D7B981F',
    'Cool Grey/Transparent Dark': '#7C88A247',
    'Cool Grey/Transparent Scratch': '#4F596D29',
    'Cool Grey/Transparent Scratch Dark': '#4F596D47',
    'Coral/Background': '#FFF6EE',
    'Coral/Basic': '#EF927B',
    'Coral/Dark': '#F19D88',
    'Coral/Disabled': '#F5BEB0',
    'Coral/Disabled Dark': '#8F584A',
    'Coral/Highlited': '#FA9379',
    'Coral/Highlited Dark': '#F9A792',
    'Coral/Hover': '#F19D88',
    'Coral/Hover Dark': '#EF927B',
    'Coral/Pressed': '#F2A895',
    'Coral/Pressed Dark': '#D7836F',
    'Coral/Transparent': '#EF927B1F',
    'Coral/Transparent Dark': '#F19D8847',
    'Coral/Transparent Scratch': '#D4816C29',
    'Coral/Transparent Scratch Dark': '#D4816C47',
    'Emerald Green/Background': '#EBFAF4',
    'Emerald Green/Basic': '#009B77',
    'Emerald Green/Dark': '#0EA582',
    'Emerald Green/Disabled': '#6CC2AE',
    'Emerald Green/Disabled Dark': '#004D3B',
    'Emerald Green/Hover': '#1CAF8D',
    'Emerald Green/Hover Dark': '#009B77',
    'Emerald Green/Pressed': '#34B698',
    'Emerald Green/Pressed Dark': '#017E61',
    'Emerald Green/Transparent': '#009B771F',
    'Emerald Green/Transparent Dark': '#009B7747',
    'Emerald Green/Transparent Scratch': '#00715729',
    'Emerald Green/Transparent Scratch Dark': '#00715747',
    'General/Black': '#000000',
    'General/Black Transparent': '#0000003D',
    'General/Black Transparent Dark': '#0000005C',
    'General/Green': '#02BE73',
    'General/Green Dark': '#1BC481',
    'General/Green Transparent': '#02BE7314',
    'General/Green Transparent Dark': '#1BC48147',
    'General/Grey 1': '#F5F5F5',
    'General/Grey 10': '#0F0F0F',
    'General/Grey 2': '#EEEEEE',
    'General/Grey 3': '#C6C4C4',
    'General/Grey 4': '#9E9E9E',
    'General/Grey 5': '#6E6E6E',
    'General/Grey 6': '#585656',
    'General/Grey 7': '#2E2E2E',
    'General/Grey 8': '#242424',
    'General/Grey 9': '#1D1D1D',
    'General/Grey Transparent': '#F5F5F5A3',
    'General/Grey Transparent Dark': '#F5F5F55C',
    'General/Lime Green': '#8DDD33',
    'General/Lime Green Dark': '#99EE38',
    'General/Lime Green Transparent': '#8DDD3314',
    'General/Lime Green Transparent Dark': '#99EE3847',
    'General/Orange': '#FF8D28',
    'General/Orange Dark': '#FF9230',
    'General/Orange Transparent': '#FF8D2814',
    'General/Orange Transparent Dark': '#FF923047',
    'General/Purple': '#BF00EA',
    'General/Purple Dark': '#DB34F2',
    'General/Purple Transparent': '#BF00EA14',
    'General/Purple Transparent Dark': '#DB34F247',
    'General/Red': '#FF383C',
    'General/Red Dark': '#FF4245',
    'General/Red Transparent': '#FF383C14',
    'General/Red Transparent Dark': '#FF424547',
    'General/Sand BG AB': '#F8F6F3',
    'General/Teal': '#00C3D0',
    'General/Teal  Transparent': '#00C3D014',
    'General/Teal  Transparent Dark': '#00D2E047',
    'General/Teal Dark': '#00D2E0',
    'General/White': '#FFFFFF',
    'General/White Transparent': '#FFFFFFA3',
    'General/White Transparent Dark': '#FFFFFF5C',
    'General/Yellow': '#FFCC00',
    'General/Yellow  Transparent': '#FFCC0014',
    'General/Yellow  Transparent Dark': '#FFD60047',
    'General/Yellow Dark': '#FFD600',
    'Gold/Basic': '#F4BB00',
    'Gold/Dark': '#E4AF00',
    'Gold/Transparent': '#F4BB001F',
    'Gold/Transparent Dark': '#E4AF0047',
    'Gold/Transparent Scratch': '#89620029',
    'Gold/Transparent Scratch Dark': '#89620047',
    'Pink/Basic': '#FF2D55',
    'Pink/Dark': '#FF375F',
    'Pink/Disabled': '#FF9DB1',
    'Pink/Disabled Dark': '#47000D',
    'Pink/Hover': '#FF375F',
    'Pink/Hover Dark': '#FF2D55',
    'Pink/Pressed': '#FF6F8C',
    'Pink/Pressed Dark': '#D20028',
    'Pink/Transparent': '#FF375F1F',
    'Pink/Transparent Dark': '#FF375F47',
    'Pink/Transparent Scratch': '#DA2F5229',
    'Pink/Transparent Scratch Dark': '#DA2F5247',
    'Royal Blue/Basic': '#3D6BCF',
    'Royal Blue/Dark': '#507AD4',
    'Royal Blue/Disabled': '#8BA6E2',
    'Royal Blue/Disabled Dark': '#25407C',
    'Royal Blue/Hover': '#507AD4',
    'Royal Blue/Hover Dark': '#3D6BCF',
    'Royal Blue/Pressed': '#6489D9',
    'Royal Blue/Pressed Dark': '#3760BA',
    'Royal Blue/Transparent': '#3D6BCF1F',
    'Royal Blue/Transparent Dark': '#507AD447',
    'Royal Blue/Transparent Scratch': '#3258AA29',
    'Royal Blue/Transparent Scratch Dark': '#3258AA47',
    'Sand military/Background': '#E2E0DB',
    'Sand military/Basic': '#6E654C',
    'Sand military/Dark': '#83785A',
    'Sand military/Disabled': '#948E7D',
    'Sand military/Disabled Dark': '#373226',
    'Sand military/Highlited': '#58513C',
    'Sand military/Highlited Dark': '#9C937B',
    'Sand military/Hover': '#58513C',
    'Sand military/Hover Dark': '#9C937B',
    'Sand military/Pressed': '#474131',
    'Sand military/Pressed Dark': '#9C937B',
    'Sand military/Transparent': '#6E654C1F',
    'Sand military/Transparent Dark': '#83785A47',
    'Sand military/Transparent Scratch': '#6E654C29',
    'Sand military/Transparent Scratch Dark 2': '#83785A47',
    'Soft Orchid/Background': '#F5F1F6',
    'Soft Orchid/Basic': '#AF88B6',
    'Soft Orchid/Dark': '#B794BD',
    'Soft Orchid/Disabled': '#CFB8D3',
    'Soft Orchid/Disabled Dark': '#69526D',
    'Soft Orchid/Highlited': '#B973C7',
    'Soft Orchid/Highlited Dark': '#D486DF',
    'Soft Orchid/Hover': '#B794BD',
    'Soft Orchid/Hover Dark': '#AF88B6',
    'Soft Orchid/Pressed': '#BFA0C5',
    'Soft Orchid/Pressed Dark': '#9D7AA4',
    'Soft Orchid/Transparent': '#AF88B61F',
    'Soft Orchid/Transparent Dark': '#B794BD47',
    'Soft Orchid/Transparent Scratch': '#7E628329',
    'Soft Orchid/Transparent Scratch Dark': '#7E628347',
    'Soft Periwinkle/Background': '#F3F5FB',
    'Soft Periwinkle/Basic': '#99AFDF',
    'Soft Periwinkle/Dark': '#A3B7E2',
    'Soft Periwinkle/Disabled': '#C2CFEC',
    'Soft Periwinkle/Disabled Dark': '#5C6986',
    'Soft Periwinkle/Highlited': '#6B8BD3',
    'Soft Periwinkle/Highlited Dark': '#8FB2FF',
    'Soft Periwinkle/Hover': '#A3B7E2',
    'Soft Periwinkle/Hover Dark': '#99AFDF',
    'Soft Periwinkle/Pressed': '#ADBFE5',
    'Soft Periwinkle/Pressed Dark': '#8A9DC9',
    'Soft Periwinkle/Transparent': '#99AFDF1F',
    'Soft Periwinkle/Transparent Dark': '#A3B7E247',
    'Soft Periwinkle/Transparent Scratch': '#7C8DB329',
    'Soft Periwinkle/Transparent Scratch Dark': '#7C8DB347',
  },
}
